import { Validator } from 'fluentvalidation-ts';
import {
  BillOfMaterialsOptionalExtraFormModel,
  BillOfMaterialsOptionalExtraFormModelValidator,
  mapBillOfMaterialsOptionalExtraToFormModel,
} from '../../bill-of-materials/billOfMaterialsOptionalExtraFormModel';
import {
  BillOfMaterialsUnitFormModel,
  BillOfMaterialsUnitFormModelValidator,
  mapToBillOfMaterialsUnitFormModel,
} from '../../bill-of-materials/billOfMaterialsUnitFormModel';
import { BillOfMaterialsPartsById } from '../../bill-of-materials/dataForEditBillOfMaterialsForm';
import { DataForEditDesignBillOfMaterialsForm } from './dataForEditDesignBillOfMaterialsForm';

export type EditDesignBillOfMaterialsFormModel = {
  units: Array<BillOfMaterialsUnitFormModel>;
  underfloorHeatingControlOptionalExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
  underfloorHeatingFloorConstructionOptionalExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
  underfloorHeatingCylinderOptionalExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
  solarOptionalExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
  heatPumpOptionalExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
};

export const getInitialEditDesignBillOfMaterialsFormModel = (
  data: DataForEditDesignBillOfMaterialsForm,
): EditDesignBillOfMaterialsFormModel => {
  return {
    units: data.units.map(mapToBillOfMaterialsUnitFormModel),
    underfloorHeatingControlOptionalExtras: data.underfloorHeatingOptionalExtras.controlOptionalExtras.map(
      mapBillOfMaterialsOptionalExtraToFormModel,
    ),
    underfloorHeatingFloorConstructionOptionalExtras: data.underfloorHeatingOptionalExtras.floorConstructionOptionalExtras.map(
      mapBillOfMaterialsOptionalExtraToFormModel,
    ),
    underfloorHeatingCylinderOptionalExtras: data.underfloorHeatingOptionalExtras.cylinderOptionalExtras.map(
      mapBillOfMaterialsOptionalExtraToFormModel,
    ),
    solarOptionalExtras: data.solarOptionalExtras.map(mapBillOfMaterialsOptionalExtraToFormModel),
    heatPumpOptionalExtras: data.heatPumpOptionalExtras.map(mapBillOfMaterialsOptionalExtraToFormModel),
  };
};

export class EditDesignBillOfMaterialsFormModelValidator extends Validator<EditDesignBillOfMaterialsFormModel> {
  constructor(partsById: BillOfMaterialsPartsById) {
    super();

    this.ruleForEach('units').setValidator(() => new BillOfMaterialsUnitFormModelValidator(partsById));

    this.ruleForEach('underfloorHeatingControlOptionalExtras').setValidator(
      () => new BillOfMaterialsOptionalExtraFormModelValidator(partsById),
    );
    this.ruleForEach('underfloorHeatingFloorConstructionOptionalExtras').setValidator(
      () => new BillOfMaterialsOptionalExtraFormModelValidator(partsById),
    );
    this.ruleForEach('underfloorHeatingCylinderOptionalExtras').setValidator(
      () => new BillOfMaterialsOptionalExtraFormModelValidator(partsById),
    );
    this.ruleForEach('solarOptionalExtras').setValidator(
      () => new BillOfMaterialsOptionalExtraFormModelValidator(partsById),
    );
    this.ruleForEach('heatPumpOptionalExtras').setValidator(
      () => new BillOfMaterialsOptionalExtraFormModelValidator(partsById),
    );
  }
}
